import useSearchParams from "@/hooks/useSearchParams";
import { useRouter } from "next/router";
import { useCallback, useMemo } from "react";
import { FilterKey } from "src/api/brand";
import { SearchQueryKey } from "src/api/search";
const useSearchParamHandler = ()=>{
    const { query  } = useRouter();
    const searchParams = useSearchParams();
    const selectedFilterList = useMemo(()=>{
        let selectedFilters = [];
        Object.keys(query).forEach((key)=>{
            if (!Object.keys(FilterKey).includes(key.toUpperCase())) return;
            if (key === FilterKey.SUBJECT) return;
            searchParams.getAll(key).map((item)=>{
                selectedFilters.push({
                    key: key,
                    value: item,
                    label: item
                });
            });
        });
        return selectedFilters;
    }, [
        searchParams,
        query
    ]);
    // 이용권 필터를 위한 라벨 추가
    const addLabelSelectedTicket = useCallback((filterItems)=>{
        if (!selectedFilterList || !filterItems) return;
        return selectedFilterList.map((item)=>{
            if (item.key === SearchQueryKey.TICKETS) {
                const foundFilter = filterItems.find((filter)=>String(filter.key) === item.key).items;
                if (!foundFilter) return item;
                const findTicketLabel = foundFilter.find((ticket)=>String(ticket.id) === item.value);
                if (!findTicketLabel) return item;
                return {
                    key: item.key,
                    value: item.value,
                    label: findTicketLabel.value
                };
            }
            return item;
        });
    }, [
        selectedFilterList
    ]);
    return {
        selectedFilterList,
        addLabelSelectedTicket
    };
};
export default useSearchParamHandler;
